import blogbg from "../componets/assets/images/homeblog.png";
import PostList from "../blog/components/PostList";

export default function BlogPage() {
  return (
    <div className="bg-[#ede6e2] min-h-screen pt-16">
      <div className="flex flex-col md:flex-row items-center justify-center gap-6 px-6 pt-8 md:pt-12 md:px-16 lg:px-32">
        <img
          className="w-36 sm:w-48 md:w-52 lg:w-64 rounded-full flex-shrink-0"
          src={blogbg}
          alt="Blog cover"
        />
        <div className="text-center md:text-left max-w-lg">
          <h1 className="text-[#000000] text-2xl sm:text-3xl font-extrabold">
            My writing
          </h1>
          <p className="text-xs sm:text-sm mt-4 text-[#000000] leading-relaxed">
            Dive into my tech journey and tech in my latest posts; a blend of
            introspection, reflection and innovation.
          </p>
        </div>
      </div>
      <div className="flex justify-center mt-6 px-4 flex-col gap-10 items-center sm:px-8 md:px-16 pt-2 lg:px-32 pb-10">
        <PostList />
      </div>
    </div>
  );
}
